import axios from "axios";
import { useState, useRef, useEffect } from "react";
export default function ChatBot() {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!input.trim() || isLoading) return;

    const userMessage = {
      id: Date.now().toString(),
      text: input,
      sender: "user",
    };

    const typingMessage = {
      id: `typing-${Date.now()}`,
      text: "در حال پردازش سوال شما...",
      sender: "bot",
      isTyping: true,
    };

    setMessages((prev) => [...prev, userMessage, typingMessage]);
    setInput("");
    setIsLoading(true);
    setError(null);

    try {
      console.log("🚀 ارسال درخواست شروع شد...");
      const response = await axios.post(
        "https://chatapi.havirard.ir/chat/",
        { text: input },  // Changed from hardcoded "fds" to actual input
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
          timeout: 60000,
        }
      );
      
      // Remove the typing message and add the actual response
      setMessages((prev) => [
        ...prev.filter(msg => msg.id !== typingMessage.id),
        {
          id: Date.now().toString(),
          text: response.data.assistant_message,  // Fixed response data access
          sender: "bot"
        }
      ]);
      console.log("✅ پاسخ دریافت شد:", response.data);
    } catch (error: any) {
      console.error("❌ خطا در درخواست:", error.message);
      setError("خطا در ارتباط با سرور. لطفاً دوباره تلاش کنید.");
      
      // Remove the typing message on error
      setMessages((prev) => prev.filter(msg => msg.id !== typingMessage.id));
      
      if (error.response) {
        console.error("وضعیت خطا:", error.response.status);
        console.error("داده خطا:", error.response.data);
      } else if (error.request) {
        console.error("پاسخی از سرور دریافت نشد!");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col dark:bg-gray-700 dark:text-white h-[80vh] mt-10 max-w-7xl mx-auto p-4 bg-gray-50 rounded-lg shadow-lg">
      <h1 className="text-2xl dark:text-gray-100 font-bold text-center mb-4 text-blue-600">
        چت بات توزیع هوشمند آرد استان لرستان{" "}
        <span className="text-gray-600 dark:text-gray-300 text-[13px]">
          (هاویر آرد)
        </span>
      </h1>

      <div className="flex-1 overflow-y-auto mb-4 space-y-4 p-2">
        {messages.map((message) => (
          <div
            key={message.id}
            className={`flex ${
              message.sender === "user" ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-xs md:max-w-md lg:max-w-lg rounded-lg px-4 py-2 ${
                message.sender === "user"
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 dark:bg-gray-600 dark:text-white text-gray-800"
              }`}
            >
              {message.text}
            </div>
          </div>
        ))}

        {messages.length === 0 && !isLoading && (
          <div className="text-center text-gray-500 dark:text-gray-400 py-8">
            سوال خود را در کادر زیر بنویسید...
          </div>
        )}

        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSubmit} className="flex gap-2 mt-4">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="flex-1 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="سوال خود را بپرسید..."
          disabled={isLoading}
        />
        <button
          type="submit"
          disabled={isLoading || !input.trim()}
          className={`
            px-4 py-2 rounded-lg
            ${
              isLoading || !input.trim()
                ? "bg-blue-400 dark:bg-blue-700 text-white cursor-not-allowed opacity-70"
                : "bg-blue-500 dark:bg-blue-600 text-white hover:bg-blue-600 dark:hover:bg-blue-700 cursor-pointer"
            }
          `}
        >
          {isLoading ? "درحال ارسال..." : "ارسال"}
        </button>
      </form>

      {error && (
        <div className="text-red-500 dark:text-red-400 text-center mt-2">
          {error}
        </div>
      )}
    </div>
  );
}